import { useEffect, useRef, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Wifi, WifiOff } from 'lucide-react'
import { useNetworkStatus } from '@/hooks/useNetworkStatus'

export function NetworkStatusBanner() {
  const { isOnline } = useNetworkStatus()
  const [showBackOnline, setShowBackOnline] = useState(false)
  const previousOnline = useRef(isOnline)

  useEffect(() => {
    if (!previousOnline.current && isOnline) {
      setShowBackOnline(true)
      const timer = setTimeout(() => setShowBackOnline(false), 2000)
      previousOnline.current = true
      return () => clearTimeout(timer)
    }
    previousOnline.current = isOnline
  }, [isOnline])

  const visible = !isOnline || showBackOnline

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key={isOnline ? 'online' : 'offline'}
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-20 left-0 right-0 z-50 flex justify-center p-4 md:bottom-4"
        >
          <div
            className={`flex items-center gap-2 rounded-lg px-4 py-3 text-sm font-medium shadow-lg ${
              isOnline
                ? 'bg-green-600 text-white'
                : 'bg-amber-500 text-white'
            }`}
          >
            {isOnline ? (
              <Wifi className="h-4 w-4 shrink-0" />
            ) : (
              <WifiOff className="h-4 w-4 shrink-0" />
            )}
            {isOnline ? 'Back online' : 'No internet connection · Showing cached data'}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
